import cx from 'classnames';
import SkeletonLoader from 'components/skeleton-loader';
import { PlaylistCardSizes } from 'components/playlist-card';

type PlaylistCardSkeletonProp = {
  size?: PlaylistCardSizes;
  className?: string;
  numberOfTitleLines?: number;
  numberOfDescriptionLines?: number;
};

const PlaylistCardSkeleton = ({
  size = 's',
  className = '',
  numberOfTitleLines = 2,
  numberOfDescriptionLines = 3
}: PlaylistCardSkeletonProp) => {
  const isLargeCard = size === 'l';
  const isSmallCard = size === 's';

  const wrapperClassName = cx({
    'flex md:block': isLargeCard,
    [className]: className
  });

  const imageClassName = cx({
    'w-1/2 shrink-0 md:w-auto': isLargeCard
  });

  const textWrapperClassName = cx({
    'w-1/2 shrink-0 pl-4 md:w-auto md:pl-0': isLargeCard
  });

  const titleClassName = cx({
    'md:mt-5 xl:mt-6': isLargeCard,
    'mt:mt-5 mt-3': isSmallCard
  });

  const contentClassName = cx({
    'md:mt-4 xl:mt-5': isLargeCard,
    'hidden md:mt-4 md:block': isSmallCard
  });

  return (
    <div className={wrapperClassName}>
      <SkeletonLoader.Image ratio={[1, 1]} className={imageClassName} />
      <div className={textWrapperClassName}>
        <SkeletonLoader.Title
          className={titleClassName}
          numberOfLines={numberOfTitleLines}
        />
        {numberOfDescriptionLines > 0 && (
          <SkeletonLoader.Content
            className={contentClassName}
            numberOfLines={numberOfDescriptionLines}
          />
        )}
      </div>
    </div>
  );
};

export default PlaylistCardSkeleton;
